import {Inject, Injectable, Optional} from '@angular/core';

import {HOME_LIBRARY_CONFIG, LibraryConfig} from './config';

@Injectable({
  providedIn: 'root' // O provisto a través del módulo de la librería
})
export class ConfigService {
  private readonly config: LibraryConfig;

  // Inyecta la configuración. @Optional() es útil si quieres proveer valores por defecto.
  constructor(@Optional() @Inject(HOME_LIBRARY_CONFIG) config?: LibraryConfig) {
    // Provee valores por defecto si no se pasa configuración
    this.config = config || {
      env: 'dev',
      apiUrl: 'https://api.defecto.com',
      enableDebugMode: false,
    };

    if (this.config.enableDebugMode) {
      console.log('MiLibreria en modo debug:', this.config);
    }
  }

  public get env(): string {
    return this.config.env;
  }
}
